import Layout from './componentes/Layout.vue';
import dashboard from './modulos/dashboard/rotas';
import login from './modulos/login/rotas';
import solicitacaoCompra from './modulos/solicitacao-compra/rotas';
import relatorio from './modulos/relatorio/rotas';
import acessoEspecialrelatorio from './modulos/acesso-especial/relatorio/rotas';
import chat from './modulos/chat/rotas';

import simulacaoPagamento from './modulos/simulacao-pagamento/rotas';
import VerificarAssinaturas from './modulos/verificar-assinaturas/rotas';

import solicitacaoPagamentoPf from './modulos/solicitacao-pagamento/fisica/rotas';
import solicitacaoPagamentoPj from './modulos/solicitacao-pagamento/juridica/rotas';
import solicitacaoPagamentoEstrangeiroPf from './modulos/solicitacao-pagamento/estrangeiro-pf/rotas';
import solicitacaoPagamentoEstrangeiroPj from './modulos/solicitacao-pagamento/estrangeiro-pj/rotas';

import solicitacaoPagamentoPfRateio from './modulos/solicitacao-pagamento-rateio/fisica/rotas';
import solicitacaoPagamentoPjRateio from './modulos/solicitacao-pagamento-rateio/juridica/rotas';

import solicitacaoReembolso from './modulos/solicitacao-reembolso/rotas';
import solicitacaoReembolsoAtividade from './modulos/solicitacao-reembolso-atividade/rotas';
import solicitacaoReembolsoEstrangeiro from './modulos/solicitacao-reembolso-estrangeiro/rotas';
import solicitacaoReembolsoTerceiro from './modulos/solicitacao-reembolso-terceiro/rotas';
import solicitacaoContratacaoPessoal from './modulos/solicitacao-contratacao-pessoal/rotas';
import transparencia from './modulos/transparencia/rotas';
import edital from './modulos/edital/rotas';
import solicitacaoFaturamento from './modulos/solicitacao-faturamento/rotas';
import solicitacaoFaturamentoMultiServicos from './modulos/solicitacao-faturamento-multiservicos/rotas';
import solicitacaoFaturamentoEstrangeiroPF from './modulos/solicitacao-faturamento-estrangeiro-pf/rotas';
import solicitacaoFaturamentoEstrangeiroPJ from './modulos/solicitacao-faturamento-estrangeiro-pj/rotas';
import liberarSolicitacao from './modulos/liberar-cancelar-solicitacao/rotas-liberar';
import cancelarSolicitacao from './modulos/liberar-cancelar-solicitacao/rotas-cancelar';
import solicitacaoAdiantamento from './modulos/solicitacao-adiantamento/rotas';
import solicitacaoBolsa from './modulos/solicitacao-bolsa/rotas';
import solicitacaoBolsaAtividades from './modulos/solicitacao-bolsa-atividades/rotas';
import paginaNaoEncontrada from './modulos/404/rotas';
import alterarSenha from './modulos/alterar-senha/rotas';
import alterarEmail from './modulos/alterar-email/rotas';
import projeto from './modulos/projeto/rotas';
import fornecedor from './modulos/fornecedor/rotas';
import webFornecedor from './modulos/web-fornecedor/rotas';
import pessoaFisica from './modulos/pessoa-fisica/rotas';
import webPessoaFisica from './modulos/web-pessoa-fisica/rotas';
import compra from './modulos/compra/rotas';
import importacao from './modulos/importacao/rotas';
import mensagem from './modulos/mensagem/rotas';
import pedido from './modulos/pedido/rotas';
import liberarsolicitacoes from './modulos/liberar-solicitacoes/rotas';
import liberarpedidoscompras from './modulos/liberar-pedidos-compras/rotas';
import liberarProvisoesPagamento from './modulos/liberar-provisoes-pagamento/rotas';
import recuperarSenha from './modulos/recuperar-senha/rotas';
import recuperarSenhaAluno from './modulos/recuperar-senha-aluno/rotas';
import recuperarSenhaFornecedor from './modulos/recuperar-senha-fornecedor/rotas';
import recuperarSenhaPessoaFisica from './modulos/recuperar-senha-pessoa-fisica/rotas';
import acompanhamentoProjeto from './modulos/acompanhamento-projeto/rotas';
import solicitacaoCursoEventoServico from './modulos/solicitacao-curso-evento-servico/rotas';
import acessos from './modulos/acessos/rotas';
import notificacoes from './modulos/notificacoes/rotas';
import contrato from './modulos/contrato/rotas';
import solicitacaoImportacao from './modulos/solicitacao-importacao/rotas';
import solicitacaoImportacaoProjeto from './modulos/solicitacao-importacao-projeto/rotas';
import aprovarPesquisaPreco from './modulos/aprovar-pesquisa-preco/rotas';
import aprovarPassagem from './modulos/aprovar-passagem/rotas';
import solicitacaoTransferencia from './modulos/solicitacao-transferencia/rotas';
import relatorioTecnicoProjeto from './modulos/relatorio-tecnico-projeto/rotas';
import solicitacaoCancelamentoContrato from './modulos/solicitacao-cancelamento-contrato/rotas';
import solicitacaoCursoEventoMatricular from './modulos/solicitacao-curso-evento-matricular/rotas';
import solicitacaoDoacaoRealizadas from './modulos/solicitacao-doacao-realizadas/rotas';
import solicitacaoEventoRealizados from './modulos/solicitacao-evento-realizados/rotas';

import terminoProjetos from './modulos/projetos-termino/rotas';
import analytics from './modulos/analytics/rotas';

const rotas = [];

let rotaPadrao = {
  path: '/',
  component: Layout,
  children: []
};

rotaPadrao.children.push(dashboard);
rotaPadrao.children.push(solicitacaoCompra);
rotaPadrao.children.push(relatorio);
rotaPadrao.children.push(acessoEspecialrelatorio);
rotaPadrao.children.push(solicitacaoPagamentoPf);
rotaPadrao.children.push(solicitacaoPagamentoPj);
rotaPadrao.children.push(solicitacaoPagamentoEstrangeiroPf);
rotaPadrao.children.push(solicitacaoPagamentoEstrangeiroPj);
rotaPadrao.children.push(solicitacaoPagamentoPfRateio);
rotaPadrao.children.push(solicitacaoPagamentoPjRateio);
rotaPadrao.children.push(solicitacaoReembolso);
rotaPadrao.children.push(solicitacaoReembolsoAtividade);
rotaPadrao.children.push(solicitacaoReembolsoEstrangeiro);
rotaPadrao.children.push(solicitacaoReembolsoTerceiro);
rotaPadrao.children.push(solicitacaoContratacaoPessoal);
rotaPadrao.children.push(solicitacaoFaturamento);
rotaPadrao.children.push(solicitacaoFaturamentoEstrangeiroPF);
rotaPadrao.children.push(solicitacaoFaturamentoEstrangeiroPJ);
rotaPadrao.children.push(solicitacaoFaturamentoMultiServicos);
rotaPadrao.children.push(solicitacaoAdiantamento);
rotaPadrao.children.push(solicitacaoBolsa);
rotaPadrao.children.push(solicitacaoBolsaAtividades);
rotaPadrao.children.push(solicitacaoCancelamentoContrato);
rotaPadrao.children.push(alterarSenha);
rotaPadrao.children.push(alterarEmail);
rotaPadrao.children.push(projeto);
rotaPadrao.children.push(mensagem);
rotaPadrao.children.push(pedido);
rotaPadrao.children.push(fornecedor);
rotaPadrao.children.push(webFornecedor);
rotaPadrao.children.push(pessoaFisica);
rotaPadrao.children.push(webPessoaFisica);
rotaPadrao.children.push(compra);
rotaPadrao.children.push(importacao);
rotaPadrao.children.push(contrato);
rotaPadrao.children.push(liberarsolicitacoes);
rotaPadrao.children.push(aprovarPesquisaPreco);
rotaPadrao.children.push(aprovarPassagem);
rotaPadrao.children.push(liberarpedidoscompras);
rotaPadrao.children.push(liberarProvisoesPagamento);
rotaPadrao.children.push(acompanhamentoProjeto);
rotaPadrao.children.push(solicitacaoCursoEventoServico);
rotaPadrao.children.push(solicitacaoImportacao);
rotaPadrao.children.push(solicitacaoImportacaoProjeto);
rotaPadrao.children.push(notificacoes);
rotaPadrao.children.push(solicitacaoTransferencia);
rotaPadrao.children.push(relatorioTecnicoProjeto);
rotaPadrao.children.push(solicitacaoCursoEventoMatricular);
rotaPadrao.children.push(solicitacaoDoacaoRealizadas);
rotaPadrao.children.push(solicitacaoEventoRealizados);
rotaPadrao.children.push(terminoProjetos);
rotaPadrao.children.push(analytics);

rotas.push(login);
rotas.push(chat);
rotas.push(transparencia);
rotas.push(edital);
rotas.push(acessos);
rotas.push(liberarSolicitacao);
rotas.push(cancelarSolicitacao);
rotas.push(recuperarSenha);
rotas.push(recuperarSenhaAluno);
rotas.push(recuperarSenhaFornecedor);
rotas.push(recuperarSenhaPessoaFisica);

rotas.push(simulacaoPagamento);
rotas.push(VerificarAssinaturas);

rotas.push(paginaNaoEncontrada);
rotas.push(rotaPadrao);

export default rotas;



// WEBPACK FOOTER //
// ./FrontEnd/rotas.js